module.exports = __webpack_public_path__ + "static/img/face.8a97016d.png";